import { retrieveLaunchParams } from '@telegram-apps/sdk';


export function useAuthHeader() {
    const launchParams = retrieveLaunchParams();
    if (launchParams && launchParams.initDataRaw) {
        const encodedInitData = window.btoa(launchParams.initDataRaw);
        return {
            'Authorization': `tma ${encodedInitData}`
        };
    }    
    return null;
}

async function handleResponse(res) {
    if (res.status == 405 || res.status == 400 || res.status == 403) {
        throw { type: "access" }
    } else if (res.status == 404) {
        throw { type: "not found" }
    } else if (res.status >= 500) {
        throw { type: "server" }
    }
    return await res.json()
}
  
export function useApi() {
    const authHeader = useAuthHeader();
    const headers = {...authHeader, 'Content-Type': 'application/json'};
    const globalDomain = "https://api.swipeapp.cc"

    const requestAccountInit = async (params) => {
        const resp = await fetch(globalDomain + `/swipe/v2/account/init?${new URLSearchParams(params)}`, {
            headers: headers,
            method: 'POST',
            credentials: 'include'
        });
        return await resp.json();
    }

    const setAccountLang = async (lang) => {
        await fetch(globalDomain + `/swipe/v2/account/language?lang=${lang}`, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
        });
    }
    
    const initiateVideoWatch = async (key) => {
        await fetch(globalDomain + `/swipe/v2/video/watching`, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({key: key})
        });
    }
  
    const endVideoWatch = async (key, watched) => {
        await fetch(globalDomain + `/swipe/v2/video/track`, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({key: key, watched: watched})
        });
    }
    
    const likeVideo = async (key, rating) => {
        await fetch(globalDomain + `/swipe/v2/video/rate`, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({key: key, rating: rating})
        });
    }

    const verifyWallet = async (wallet) => {
        await fetch(globalDomain + `/swipe/v2/account/verify?wallet=${wallet}`, {
            headers: headers,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({})
        });
    }

    const getVideoMetadata = async (key) => {
        const resp = await fetch(globalDomain + `/swipe/v2/video/metadata?key=${key}`, {
            headers: headers,
            credentials: 'include'
        });
        return await handleResponse(resp);
    }

    const getFeedItemsV2 = async () => {
        const resp = await fetch(globalDomain + '/swipe/v2/video/feed', {
            headers: headers,
            credentials: 'include'
        })
        return await handleResponse(resp);
    }

    const getDirectItemV2 = async (startParam) => {
        const resp = await fetch(globalDomain + `/swipe/v2/video/get?user=${startParam.username}&msg_id=${startParam.message}`, {
            headers: headers,
            credentials: 'include'
        });
        return await handleResponse(resp);
    }
    
    const getUserBalance = async () => {
        const resp = await fetch(globalDomain + `/swipe/v1/account/balance`, {
            headers: headers,
        })
        return await resp.json();
    }
  
    return {verifyWallet, getVideoMetadata, setAccountLang, getUserBalance, requestAccountInit, getFeedItemsV2, getDirectItemV2, initiateVideoWatch, endVideoWatch, likeVideo}
}